// extracted by mini-css-extract-plugin
export default {"container":"SessionExpired_container__TP4Xv","content":"SessionExpired_content__zerO3"};